import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645924bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TTNList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ttn_list_item = _resolveComponent("ttn-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_list, {
      loading: _ctx.loading,
      items: _ctx.items
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(_component_ttn_list_item, { item: item }, null, 8, ["item"])
      ]),
      _: 1
    }, 8, ["loading", "items"])
  ]))
}